const SentEmail = () =>
  import(
    /* webpackChunkName: "message-sent-email" */ '@/pages/message/sent/email/index.vue'
  )

export default {
  path: 'email',
  meta: {
    label: 'email',
    auth: 'email'
  },
  component: {
    name: 'Email',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageSentEmail',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SentEmail
    }
  ]
}
